export const getStatusColor = (value) => {
  const colors = {
    Active: 'green',
    Paused: 'yellow',
    Cancelled: 'red'
  }

  const color = colors[value]

  if (!color) {
    throw new Error('No color defined.')
  }

  return color
}
